import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
    setSuccess(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;

    if (!name || !email || !phone || !message) {
      setError("Please fill in all fields.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setError("");

    const templateParams = {
      from_name: name,
      email: email,
      phone,
      message,
    };

    emailjs
      .send(
        "service_hd8b0t9",
        "template_xph9rva",
        templateParams,
        "666dxgiXyhuCF9Zyu"
      )
      .then(() => {
        setLoading(false);
        setSuccess(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to send message. Try again later.");
      });
  };

  return (
    <Container
      sx={{
        py: 10,
        maxWidth: "600px !important",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#b1976b",
          mb: 3,
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
        }}
      >
        Contact Us
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
          width: "100%",
          mt: 2,
        }}
      >
        <TextField
          label="Name"
          name="name"
          variant="outlined"
          fullWidth
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="Email"
          name="email"
          variant="outlined"
          fullWidth
          value={formData.email}
          onChange={(e) => {
            const lower = e.target.value.toLowerCase();
            setFormData({ ...formData, email: lower });
            setError("");
            setSuccess(false);
          }}
        />
        <TextField
          label="Phone"
          name="phone"
          variant="outlined"
          fullWidth
          value={formData.phone}
          onChange={handleChange}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            maxLength: 10,
            onInput: (e) => {
              e.target.value = (e.target.value || "")
                .replace(/\D/g, "")
                .slice(0, 10);
            },
          }}
        />
        <TextField
          label="Message"
          name="message"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={formData.message}
          onChange={handleChange}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: "#b1976b",
            color: "#fff",
            fontWeight: 500,
            textTransform: "none",
            py: 1.2,
            "&:hover": { backgroundColor: "#a88d5d" },
          }}
        >
          {loading ? "Sending..." : "Send Message"}
        </Button>

        {error && <Alert severity="error">{error}</Alert>}
        {success && (
          <Alert severity="success">Message sent successfully!</Alert>
        )}
      </Box>
    </Container>
  );
};

export default Contact;
